import cookie from 'vue-cookies';
import { USER_TYPE } from '@/utils/const';

export const AGENT_DASHBOARD_PATH = '/agent-dashboard';
export const CUSTOMER_DASHBOARD_PATH = '/dashboard';

const AUTH_PATH_PREFIXES = ['/signin', '/signup', '/confirm-otp', '/forgot-password', '/reset-password'];

const CUSTOMER_PROTECTED_PREFIXES = [
  CUSTOMER_DASHBOARD_PATH,
  '/buy/products',
  '/buy/pa',
  '/buy/motor',
  '/buy-cover',
  '/saved-quotes',
  '/my-policies',
  '/claims',
  '/statement',
  '/notifications',
  '/travel-quote-summary',
  '/policy-result',
];

const CUSTOMER_PUBLIC_PREFIXES = [
  '/request-for-quotation',
  '/travel/',
  '/providers',
  '/quote',
];

export function isAgentUser() {
  return cookie.get(USER_TYPE) === 'agent';
}

export function isAuthPath(path) {
  return AUTH_PATH_PREFIXES.some((p) => path === p || path.startsWith(`${p}/`) || path.startsWith(p));
}

export function isAgentProtectedRoute(path) {
  return path === AGENT_DASHBOARD_PATH || path.startsWith('/agent');
}

export function isCustomerProtectedRoute(path) {
  return CUSTOMER_PROTECTED_PREFIXES.some((p) => path === p || path.startsWith(`${p}/`));
}

export function isCustomerPublicRoute(path) {
  return CUSTOMER_PUBLIC_PREFIXES.some((p) => path === p || path.startsWith(p));
}

/**
 * Customer portal routes should not hard-redirect to /error or 404 pages (use toasts instead).
 */
export function shouldSkipGlobalErrorRedirect(router, store) {
  const path = router.currentRoute?.path || '';
  if (path.startsWith('/agent')) return true;
  if (path === '/error' || path === '/no-internet') return false;

  if (isCustomerPublicRoute(path)) return true;

  const authenticated = store?.getters?.['auth/isAuthenticated'];
  if (!isAgentUser() && authenticated && !isAuthPath(path)) {
    return true;
  }

  return false;
}
